import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export const HowItWorks = () => {
  const { language } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      id="how-it-works"
      ref={ref}
      className="py-24 md:py-32 bg-white dark:bg-slate-900 theme-transition"
      data-testid="how-it-works-section"
    >
      <div className="section-container">
        {/* Section Header */}
        <div className={`text-center mb-16 ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
          <h2 className="section-title mb-4" data-testid="how-it-works-title">
            {translations.howItWorks.title[language]}
          </h2>
          <p className="section-subtitle mx-auto">
            {translations.howItWorks.subtitle[language]}
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden md:block absolute top-7 left-[calc(16.67%-28px)] right-[calc(16.67%-28px)] h-0.5 bg-gradient-to-r from-indigo-600 via-violet-600 to-indigo-600" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {translations.howItWorks.steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex flex-col items-center text-center ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}
                style={{ animationDelay: `${index * 0.15}s` }}
                data-testid={`step-${index + 1}`}
              >
                {/* Step Number */}
                <div className="step-number mb-6 relative z-10">
                  {index + 1}
                </div>

                {/* Content */}
                <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 border border-slate-200 dark:border-slate-700 shadow-lg w-full">
                  <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-3">
                    {step.title[language]}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-400">
                    {step.description[language]}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
